import { render } from "./HowToQuote.vue?vue&type=template&id=b85c6d4c&ts=true"
import script from "./HowToQuote.vue?vue&type=script&lang=ts"
export * from "./HowToQuote.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__